module.exports = [{
  code: 0,
  name: 'created',
  title: 'créé'
},{
  name: 'debited',
  title: 'debité',
  code: 1
},{
  name: 'cancelled',
  title: 'annulé',
  code: 2
},{
  title: 'échoué',
  code: 3,
  name: 'failed'
},{
  code: 4,
  name: 'error',
  title: 'erreur'
}];